// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".record-container[data-v-1140d64c] {\n  margin: 0.53333rem;\n  padding: 0.26667rem 0.53333rem;\n  background: #fff;\n  border-radius: 0.26667rem;\n  box-sizing: border-box;\n  height: calc(100vh - 1.06667rem);\n}\n.record-container .header-image[data-v-1140d64c] {\n    width: 100%;\n    margin-bottom: 0.53333rem;\n}\n", ""]);
// Exports
module.exports = exports;
